<template>
    <v-app>
        <v-container fluid>
            <role-setup  v-if="dialog" :dialog="dialog" :data="data" @update:dialog="dialog = $event" />  
            <template v-if="$insertAccess($route.fullPath)">
                <v-form @submit.prevent="submit">
                    <v-row>
                        <v-col cols="12">
                            <v-expansion-panels v-model="panel">
                                <v-expansion-panel>
                                    <v-expansion-panel-title class="panel-header">Role Permission</v-expansion-panel-title>
                                    <v-expansion-panel-text class="expansion-padding">
                                            <v-row class="no-gutters justify-center">
                                                <v-col lg="3" md="3" cols="12">    
                                                        <v-autocomplete
                                                            label="Select Company"
                                                            density="compact"
                                                            single-line
                                                            variant="outlined"
                                                            bg-color="grey-lighten-4"
                                                            v-model="company_id.value.value"
                                                            :error-messages="company_id.errorMessage.value"
                                                            clearable
                                                            :items="getCompanyList.filter(item=> item.status == 1)"
                                                            :item-title="item => `${item.name} - ${item.code}`"                                                  
                                                            item-value="id" 
                                                            autocomplete="off"
                                                        ></v-autocomplete>
                                                </v-col>

                                                <v-col lg="3" md="3" cols="12">    
                                                        <v-autocomplete
                                                            label="Select Branch"
                                                            density="compact"
                                                            single-line
                                                            variant="outlined"
                                                            bg-color="grey-lighten-4"
                                                            v-model="branch_id.value.value"
                                                            :error-messages="branch_id.errorMessage.value"
                                                            clearable
                                                            :items="getBranchList.filter(item => item.company_id == company_id.value.value)"
                                                            :item-title="item => `${item.code} - ${item.name}`"                                                  
                                                            item-value="id"
                                                            autocomplete="off"
                                                            @update:modelValue="getModulesByBranch" 
                                                        ></v-autocomplete>                                                                                             
                                                </v-col>

                                                <v-col lg="3" md="3" cols="12">
                                                    <v-autocomplete
                                                        label="Select Role"
                                                        density="compact"
                                                        single-line
                                                        variant="outlined"
                                                        bg-color="grey-lighten-4"
                                                        v-model="role_id.value.value"
                                                        clearable
                                                        hide-details
                                                        :items="getSchema.filter(item => item.branch_id == this.branch_id.value.value)"
                                                        :item-title="item => `${item.code} - ${item.name}`"                                                  
                                                        item-value="id"    
                                                        append-icon="mdi mdi-plus"
                                                        @update:modelValue="getRolePermission"
                                                        @click:append="addRoleUrl"
                                                        autocomplete="off" 
                                                    >                                              
                                                    </v-autocomplete> 
                                                </v-col>
                                            </v-row>


                                    <!-- Role Permission -->
                                        <v-row v-if="section_show">
                                            <v-col cols="12"><v-alert text="Role Permission" density="compact" color="success"></v-alert> </v-col>
                                            <v-col lg="6" md="6" cols="12" xs="12">
                                                <v-skeleton-loader :loading="module_loading" type="heading"> 
                                                <v-row>                                    
                                                    <v-col cols="12">      
                                                        <div v-for="(item, index) in getModule" :key="index">                                                         
                                                            <v-expansion-panels v-if="index < moduleLength" class="my-4">
                                                                <v-expansion-panel>
                                                                        <v-expansion-panel-title class="panel-header-role">{{ item.companies_modules.module.name }}</v-expansion-panel-title>
                                                                        <v-expansion-panel-text>
                                                
                                                                                <v-table class="permission-table" density="compact" v-for="(sub_module, index2) in item.companies_modules.module.sub_module" :key="index2">
                                                                                    <thead>
                                                                                    <tr>
                                                                                        <th class="text-left" style="width:60%"><strong>{{ sub_module.name }}</strong></th>
                                                                                        <th class="text-left" style="width:10%">View</th>
                                                                                        <th class="text-left" style="width:10%">Insert</th>
                                                                                        <th class="text-left" style="width:10%">Update</th>
                                                                                        <th class="text-left" style="width:10%">Delete</th>
                                                                                    </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        <tr v-for="(menu, index3) in sub_module.menu" :key="menu.id" v-if="sub_module.menu.length > 0" :class="{ 'striped-row': index3 % 2 == 1 }">
                                                                                            <td class="text-left pl-25" > <v-icon icon="mdi mdi-square-small" size="x-large"></v-icon>{{ menu.name }}</td>
                                                                                            <td class="py-0">
                                                                                                <span>
                                                                                                    <v-checkbox   
                                                                                                        :id="'menu_view_'+menu.id"                         
                                                                                                        single-line
                                                                                                        hide-details  
                                                                                                        density="compact"
                                                                                                        color="indigo" 
                                                                                                        v-model="menuViewPermissions[menu.id]"                                  
                                                                                                    ></v-checkbox>
                                                                                                </span>

                                                                                            </td>
                                                                                            <td class="py-0">
                                                                                                <span v-if="menu.insert > 0">
                                                                                                    <v-checkbox   
                                                                                                        :id="'menu_insert_'+menu.id"                         
                                                                                                        single-line
                                                                                                        hide-details  
                                                                                                        density="compact"
                                                                                                        color="primary" 
                                                                                                        v-model="menuInsertPermissions[menu.id]"                                  
                                                                                                    ></v-checkbox>
                                                                                                </span>

                                                                                            </td>
                                                                                            <td class="py-0">
                                                                                                <span v-if="menu.update > 0">
                                                                                                    <v-checkbox     
                                                                                                        :id="'menu_update_'+menu.id"                       
                                                                                                        single-line
                                                                                                        hide-details  
                                                                                                        density="compact"
                                                                                                        color="info"    
                                                                                                        v-model="menuUpdatePermissions[menu.id]"                                                         
                                                                                                    ></v-checkbox>
                                                                                                </span>
                                                                                            </td>
                                                                                            <td class="py-0">
                                                                                                <span v-if="menu.delete > 0">
                                                                                                    <v-checkbox      
                                                                                                        :id="'menu_delete_'+menu.id"                      
                                                                                                        single-line
                                                                                                        hide-details  
                                                                                                        density="compact"
                                                                                                        color="red" 
                                                                                                        v-model="menuDeletePermissions[menu.id]"                                                                         
                                                                                                    ></v-checkbox>
                                                                                                </span>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr v-else>
                                                                                            <td colspan="4" class="text-center"><small class="red" >Menu Not Found</small></td>
                                                                                        </tr>
                                                                                    
                                                                                    </tbody>
                                                                                </v-table>
                                                                                                
                                                                        </v-expansion-panel-text>
                                                                    </v-expansion-panel>
                                                            </v-expansion-panels>       
                                                        </div>                                                    
                                                    </v-col>
                                                </v-row>
                                                </v-skeleton-loader>
                                            </v-col>

                                            <v-col lg="6" md="6" cols="12" xs="12">
                                                <v-skeleton-loader :loading="module_loading" type="heading"> 
                                                <v-row>                                    
                                                    <v-col cols="12">      
                                                        <div v-for="(item, index) in getModule" :key="index">                                                         
                                                            <v-expansion-panels v-if="index >= moduleLength" class="my-4">
                                                                <v-expansion-panel>
                                                                        <v-expansion-panel-title class="panel-header-role">{{ item.companies_modules.module.name }}</v-expansion-panel-title>
                                                                        <v-expansion-panel-text>
                                                                            <v-table class="permission-table"  density="compact" v-for="(sub_module, index2) in item.companies_modules.module.sub_module" :key="index2">
                                                                                    <thead>
                                                                                    <tr>
                                                                                        <th class="text-left" style="width:60%"><strong>{{ sub_module.name }}</strong></th>
                                                                                        <th class="text-center" style="width:10%">View</th>
                                                                                        <th class="text-center" style="width:10%">Insert</th>
                                                                                        <th class="text-center" style="width:10%">Update</th>
                                                                                        <th class="text-center" style="width:10%">Delete</th>
                                                                                    </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        <tr v-for="(menu, index3) in sub_module.menu" :key="menu.id" v-if="sub_module.menu.length > 0" hover="true"  :class="{ 'striped-row': index3 % 2 == 1 }">
                                                                                            <td class="text-left pl-25" > <v-icon icon="mdi mdi-square-small" size="x-large"></v-icon>{{ menu.name }}</td>
                                                                                            <td class="py-0">
                                                                                                <span v-if="menu.insert > 0">
                                                                                                    <v-checkbox   
                                                                                                        :id="'menu_view_'+menu.id"                         
                                                                                                        single-line
                                                                                                        hide-details  
                                                                                                        density="compact"
                                                                                                        color="indigo"                                                                                      
                                                                                                        v-model="menuViewPermissions[menu.id]"                                                                                   
                                                                                                    ></v-checkbox>
                                                                                                </span>

                                                                                            </td>
                                                                                            <td class="py-0">
                                                                                                <span v-if="menu.insert > 0">
                                                                                                    <v-checkbox   
                                                                                                        :id="'menu_insert_'+menu.id"                         
                                                                                                        single-line
                                                                                                        hide-details  
                                                                                                        density="compact"
                                                                                                        color="primary"                                                                                      
                                                                                                        v-model="menuInsertPermissions[menu.id]"                                                                                   
                                                                                                    ></v-checkbox>
                                                                                                </span>

                                                                                            </td>
                                                                                            <td class="py-0">
                                                                                                <span v-if="menu.update > 0">
                                                                                                    <v-checkbox     
                                                                                                        :id="'menu_update_'+menu.id"                       
                                                                                                        single-line
                                                                                                        hide-details  
                                                                                                        density="compact"
                                                                                                        color="info"   
                                                                                                        v-model="menuUpdatePermissions[menu.id]"                                                        
                                                                                                    ></v-checkbox>
                                                                                                </span>
                                                                                            </td>
                                                                                            <td class="py-0">
                                                                                                <span v-if="menu.delete > 0">
                                                                                                    <v-checkbox      
                                                                                                        :id="'menu_delete_'+menu.id"                      
                                                                                                        single-line
                                                                                                        hide-details  
                                                                                                        density="compact"
                                                                                                        color="red" 
                                                                                                        v-model="menuDeletePermissions[menu.id]"                                                                           
                                                                                                    ></v-checkbox>
                                                                                                </span>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr v-else>
                                                                                            <td colspan="4" class="text-center"><small class="red" >Menu Not Found</small></td>
                                                                                        </tr>
                                                                                    
                                                                                    </tbody>
                                                                            </v-table>

                                                                        </v-expansion-panel-text>
                                                                    </v-expansion-panel>
                                                            </v-expansion-panels>       
                                                        </div>                                                    
                                                    </v-col>
                                                </v-row>
                                                </v-skeleton-loader>
                                            </v-col>
                                    
                                            
                                            <v-col cols="12"  v-if="!module_loading">
                                                <div class="text-center">
                                                    <v-btn                              
                                                        class="bg-brand w-25"
                                                        type="submit"     
                                                        v-if="getModule.length > 0"                                    
                                                        >Save</v-btn>  
                                                </div>
                                            </v-col>

                                            <v-col cols="10" v-if="!module_loading" class="mx-auto mb-4">
                                                <v-alert v-if="getModule.length == 0" closable text="Data Not Found!" density="compact" type="warning"></v-alert>                                      
                                            </v-col>
                                        </v-row>                                              
                                    <!-- Close Role Permission -->
                       
                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>

                    <!-- Data table -->
                </v-form>
            </template>
            <template v-else>
                <v-row>
                    <v-col cols="12">
                        <v-alert
                            color="warning"
                            theme="dark"
                            icon="mdi mdi-alert"
                            border
                            >
                            Permission Not Found
                        </v-alert>
                    </v-col>
                </v-row>
            </template>


        </v-container>
    </v-app>
</template>

<script>

import breadCrumbs from '@/components/utils/breadCrumbs.vue';
import roleSetup from '@/components/module/administration/roleManagement/roleSetup.vue';
import {useStore} from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref, watch } from 'vue';
import { toast } from 'vue3-toastify';
import { useRouter } from 'vue-router'; 

export default {
        components: {
            breadCrumbs,
            roleSetup
        },
        data: () => ({
            panel: [0],
            panel2: [0],
            module_loading: false,
            form_loading: true,
            moduleLength: 0,
            section_show: false,
            errorMessages:'',
            search: "",
            menuViewPermissions: {},
            menuInsertPermissions: {},
            menuUpdatePermissions: {},
            menuDeletePermissions: {},
            dialog: false,
            data:{},
        }),
        watch: {
        },
        created(){
            if(this.$store.getters.getCompanyList.length == 0){this.$store.dispatch('getCompanyList')};
            if(this.$store.getters.getBranchList.length == 0){this.$store.dispatch('getBranchList')};
            if(this.$store.getters.getRoleList.length == 0){this.$store.dispatch('getRoleList') };
        },
        computed:{
            getSchema() {
                return this.$store.getters.getRoleList;
            },
            getModule() {
                let data = this.$store.getters.getModulesByBranch;
                this.moduleLength = Math.ceil(data.length / 2);
                return data;
            },
            getCompanyList() {
                return this.$store.getters.getCompanyList;
            },
            getBranchList(){
                let data = this.$store.getters.getBranchList;
                if(data.length > 0){
                    return data.filter((item) => item.status == 1);
                }
                return [];
            }
        },
        methods: {
            addRoleUrl() {
                this.data = {
                    id: '',
                    name: '',
                    code: '',
                    remarks: '',
                    status: 1,
                };
                this.dialog = true;
            },
            getDataFromApi(){
                this.loading = true;
                this.$store.dispatch('getRoleList')
                .then(data => {
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    toast.error(error.response.data.message); 
                })
                .then(always => {
                    this.loading = false;
                })
            },
            getModulesByBranch(){
                const branch_id =  this.branch_id.value.value;
                if(branch_id != null){
                    this.role_id.value.value = null; 
                    this.section_show = true;
                    this.module_loading = true;
                    this.$store.dispatch('getModulesByBranch',branch_id).then(() => {
                        this.module_loading = false;
                        console.log('test');
                    })
                }
                else {
                    this.menuViewPermissions = {};
                    this.menuInsertPermissions = {};
                    this.menuUpdatePermissions = {};
                    this.menuDeletePermissions = {};  
                    this.role_id.value.value = null;                  
                    this.$store.commit('UNSET_GET_ROLES_BY_BRANCH');
                    this.$store.commit('UNSET_MODULE_LIST');
                }
            
            },
            getRolePermission() {
                var self = this;
                if(this.role_id.value.value != null){
                    this.$store.dispatch("getRolePermission", {role_id:this.role_id.value.value})
                    .then((response) => {
                        var data = response.data.data;   
                        this.menuViewPermissions = {};
                        this.menuInsertPermissions = {};
                        this.menuUpdatePermissions = {};
                        this.menuDeletePermissions = {};    
                        data.forEach(function (element, index) {
                                if(element.view == 1){
                                    self.menuViewPermissions[element.menu_id] = true;
                                }
                                if(element.insert == 1){
                                    self.menuInsertPermissions[element.menu_id] = true;
                                }
                                if(element.update == 1){
                                    self.menuUpdatePermissions[element.menu_id] = true;
                                }
                                if(element.delete == 1){
                                    self.menuDeletePermissions[element.menu_id] = true;
                                }
                            });

                    })
                    .catch((error) => {            
         
                    })
                }
                else{
                    this.menuViewPermissions = {};
                    this.menuInsertPermissions = {};
                    this.menuUpdatePermissions = {};
                    this.menuDeletePermissions = {}; 
                }              
            }
        },
        setup() {
            
            const { handleSubmit} = useForm({
                validationSchema: yup.object({
                    role_id: yup.number().positive().integer().required().label('Role Name'),
                    branch_id: yup.number().positive().integer().required().label('Branch Name'),       
                }),
            });

            const role_id = useField('role_id');
            const company_id = useField('company_id');
            const branch_id = useField('branch_id');
            const errorMessages  = ref('');
            const loading  = ref('');
            const menuViewPermissions  =  ref({});
            const menuInsertPermissions  =  ref({});
            const menuUpdatePermissions  =  ref({});
            const menuDeletePermissions  =  ref({});
            const store = useStore();
            const router = useRouter();

            watch(() => company_id.value.value, () => {
                branch_id.value.value = null;
            });

            const submit = handleSubmit((values) => { 
                 // Data rearrange
                    var data = {};
                    data.view = menuViewPermissions.value;            
                    data.insert = menuInsertPermissions.value;            
                    data.update = menuUpdatePermissions.value;            
                    data.delete = menuDeletePermissions.value; 
                    const mergedData = Object.keys(data).reduce((result, key) => {
                        const subData = data[key];
                        Object.keys(subData).forEach(subKey => {
                            if (subData[subKey] == true) { 
                                if (!result[subKey]) {
                                    result[subKey] = [];
                                }
                                result[subKey].push(key);
                            }
                        });
                        return result;
                    }, {});

                    values.data = mergedData; 
                //close data rearrange
                
                store.dispatch("saveRolePermission", values)
                    .then((response) => {                       
                        var menu_ind = response.data;
                        if(menu_ind.hasOwnProperty('menu')){
                            toast.success('Your Permission Updated');
                            router.push('/home/dashboard');
                        }
                        else{
                            toast.success(response.data.message);
                        } 
                    })
                    .catch((error) => { 
                        toast.error(error.response.data.message);              
                    })


            })
            return {
            submit,
            errorMessages,
            role_id,
            company_id,
            branch_id,
            menuViewPermissions,
            menuInsertPermissions,
            menuUpdatePermissions,
            menuDeletePermissions,
            loading
            }
        },
        mounted() {
            // this.getDataFromApi();
            this.$store.commit('UNSET_MODULE_LIST')         
          }  
    }
</script>

<style >
    .permission-table tbody tr td{
        font-size: 16px !important;
    }
    .pl-25{
        padding-left:25px !important;
    }
    .striped-row {
        background-color: #d7d7d738;
    }
</style>